import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useGetLiteratureReviewService } from '@/services/literatureReviews';
import { MarkdownText } from '@/shared/MarkdownText';
import { type FC } from 'react';
import { useParams } from 'react-router';

export const WarningModal: FC<{
  type: 'prompt' | 'run_screening';
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoading: boolean;
  onConfirm: () => void;
}> = ({ type, isOpen, onOpenChange, isLoading, onConfirm }) => {
  const { literatureReview_id } = useParams();
  const { literatureReview } =
    useGetLiteratureReviewService(literatureReview_id);

  const abstractScreening = literatureReview?.abstractScreening;

  if (!abstractScreening) {
    return null;
  }

  const markdownText = `
Changing criteria requires re-screening all papers.

This will:
- Delete all ${abstractScreening.screeningDecisionsCount} screening decisions (including ${abstractScreening.validatedCount} validated papers)
- Remove any manual overrides or edits you've made
${type === 'prompt' ? `- Replace your ${abstractScreening.criteriaCount} existing exclusion criteria` : ''}

⚠️ This action cannot be undone. Consider exporting your current results before proceeding.
`;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="pr-1">
            {type === 'prompt'
              ? 'This action will delete screening results and regenerate new criteria.'
              : 'Are you sure? This action will delete and regenerate your screening results.'}
          </DialogTitle>
        </DialogHeader>
        <MarkdownText>{markdownText}</MarkdownText>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={onConfirm} loading={isLoading}>
            Delete and regenerate
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
